import { Box, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { Product } from "utils/types/ProductTypes";
import { getProducts } from "utils/api/private/ProductApiService";
import { useWindowSize } from "utils";
import { ProductBestsellerCard } from "./ProductBestsellerCard";

export const BestSeller = () => {
  const [bestseller, setBestseller] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const { isPC } = useWindowSize();

  useEffect(() => {
    const fetchBestsellers = async () => {
      try {
        setLoading(true);
        const response = await getProducts({
          isBestseller: true,
          limit: 1,
          page: 1,
        });
        if (response.data && response.data.length > 0) {
          setBestseller(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching bestseller:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBestsellers();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "center", width: "100%", p: 1 }}
      >
        <Skeleton
          variant="rectangular"
          width={isPC ? "70vw" : "92vw"}
          height={400}
        />
      </Box>
    );
  }
  if (!bestseller) {
    return null; // Don't render anything if no bestseller is found
  }

  return <ProductBestsellerCard product={bestseller} />;
};
